if (window.innerWidth < 767) {
  console.log("hello")
  const enquire_form = document.querySelector(".rugshed-enquiry-form-group");

  if (enquire_form) {
    const cross = document.querySelector(".rugshed-cross-button");
    const form_title = enquire_form.querySelector("h3");
    const form = enquire_form.querySelector("form");

    form_title.addEventListener("click", (e) => {
      form.classList.toggle('active')
    });

    cross.addEventListener("click", (e) => {
      form.classList.toggle('active')
    });
  }
}

/* ============================================================
   RUG SHED — WISHLIST BRIDGE (added 2026-09-26)
   1. Collection-grid hearts (.rcd-fav desktop, .rmob-wish mobile) used to
      save product IDs to an orphaned 'rcd_wishlist' key that nothing read.
      They now go into the real wishlist ('rgs_wishlist') via rgsWlToggle,
      so the drawer, bubble and home-trial booking all see them.
   2. Adds a wishlist heart to the product-page gallery (desktop .rgd-gal,
      mobile .rgs-gal), using the data already on the Home Trial button.
   3. Keeps every heart on the page in sync after adds/removes, AJAX
      filtering and "load more".
   ============================================================ */
(function(){
  var KEY='rgs_wishlist';
  var HEART='<svg fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"/></svg>';

  function getWl(){try{return JSON.parse(localStorage.getItem(KEY)||'[]');}catch(e){return[];}}
  function handleFromUrl(u){
    try{var p=new URL(u,location.origin).pathname.split('/');var i=p.indexOf('products');return i>-1?(p[i+1]||''):'';}catch(e){return '';}
  }
  function cardData(btn){
    var card=btn.closest('.rcd-pc,.rmob-pc');
    if(!card)return null;
    var link=card.matches('a')?card:card.querySelector('a[href*="/products/"]');
    var url=link?(link.getAttribute('href')||'').split('?')[0]:'';
    var handle=handleFromUrl(url);
    if(!handle)return null;
    var name=card.querySelector('.rcd-pc-name,.rmob-pc-name');
    var priceEl=card.querySelector('.rcd-pc-price,.rmob-pc-price');
    var price='';
    if(priceEl){
      var c=priceEl.cloneNode(true);
      c.querySelectorAll('.rcd-pc-was,.rmob-pc-was').forEach(function(x){x.remove();});
      price=c.textContent.trim();
    }
    var img=card.querySelector('img');
    return {handle:handle,title:name?name.textContent.trim():'',price:price,img:img?(img.currentSrc||img.src):'',url:url};
  }
  function fill(btn,d){['handle','title','price','img','url'].forEach(function(k){btn.dataset[k]=d[k]||'';});}

  function sync(){
    var handles=getWl().map(function(p){return p.handle;});
    document.querySelectorAll('.rcd-fav,.rmob-wish,.rgs-wl-heart').forEach(function(btn){
      if(!btn.dataset.handle){var d=cardData(btn);if(d)fill(btn,d);}
      var on=handles.indexOf(btn.dataset.handle)>-1;
      btn.classList.toggle('saved',on);
      btn.setAttribute('aria-pressed',on?'true':'false');
      btn.setAttribute('aria-label',on?'Remove from wishlist':'Save to wishlist');
    });
  }
  window.rsWlSync=sync;

  function gridToggle(btn,e){
    if(e){e.preventDefault();e.stopPropagation();}
    if(!window.rgsWlToggle)return;
    if(!btn.dataset.handle){var d=cardData(btn);if(!d)return;fill(btn,d);}
    window.rgsWlToggle(btn);
    sync();
  }
  window.rcdToggleWish=gridToggle;
  window.rmobWish=gridToggle;

  function injectPdpHearts(){
    [['.rgd-gal','#rgdTrialBtn'],['.rgs-gal','#rgsTrialBtn']].forEach(function(p){
      var gal=document.querySelector(p[0]),src=document.querySelector(p[1]);
      if(!gal||!src||gal.querySelector('.rs-pdp-heart'))return;
      var b=document.createElement('button');
      b.type='button';
      b.className='rgs-wl-heart rs-pdp-heart';
      fill(b,src.dataset);
      b.innerHTML=HEART;
      b.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();if(window.rgsWlToggle){window.rgsWlToggle(b);sync();}});
      gal.appendChild(b);
    });
  }

  function wrap(name){
    var orig=window[name];
    if(typeof orig!=='function'||orig.__rsWrapped)return;
    var w=function(){var r=orig.apply(this,arguments);setTimeout(sync,350);return r;};
    w.__rsWrapped=true;
    window[name]=w;
  }

  function init(){
    window.rcdToggleWish=gridToggle;
    window.rmobWish=gridToggle;
    injectPdpHearts();
    ['rgsWlClose','rgsWlRemove','rgsWlClearAll','rgdBookTrial','rgdOpenWishlistHint','rgsBookTrial','rgsOpenWishlistHint'].forEach(wrap);
    sync();
    var t;
    new MutationObserver(function(){clearTimeout(t);t=setTimeout(sync,150);}).observe(document.body,{childList:true,subtree:true});
    window.addEventListener('storage',function(e){if(e.key===KEY)sync();});
    window.addEventListener('pageshow',sync);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* ============================================================
   RUG SHED — DESKTOP WHATSAPP CHAT PANEL (added 2026-09-26)
   - Every page: the floating .whatsapp-icon link gets a pre-filled message
     (product pages already set their own, rug-specific one).
   - Desktop (>=1024px): the icon becomes a "Chat with us" pill. Clicking it
     opens a small panel with a QR code (scan with your phone -> WhatsApp opens
     with the message ready) and a button to open WhatsApp on this computer.
   - QR codes are generated here, no third-party script (rsQr below).
   ============================================================ */
(function(){
  var NUMBER='447867610656';

  /* ---------- rsQr: minimal QR encoder (byte mode, ECC L, auto version, masks scored) ---------- */
  var rsQr=(function(){
    var ECC={L:[-1,7,10,15,20,26,18,20,24,30,18,20,24,26,30,22,24,28,30,28,28,28,28,30,30,26,28,30,30,30,30,30,30,30,30,30,30,30,30,30,30],
             M:[-1,10,16,26,18,24,16,18,22,22,26,30,22,22,24,24,28,28,26,26,26,26,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28,28]};
    var BLK={L:[-1,1,1,1,1,1,2,2,2,2,4,4,4,4,4,6,6,6,6,7,8,8,9,9,10,12,12,12,13,14,15,16,17,18,19,19,20,21,22,24,25],
             M:[-1,1,1,1,2,2,4,4,4,5,5,5,8,9,9,10,10,11,13,14,16,17,17,18,20,21,23,25,26,28,29,31,33,35,37,38,40,43,45,47,49]};
    var FMT={L:1,M:0};
    function rawMods(v){var r=(16*v+128)*v+64;if(v>=2){var n=Math.floor(v/7)+2;r-=(25*n-10)*n-55;if(v>=7)r-=36;}return r;}
    function dataCw(v,e){return Math.floor(rawMods(v)/8)-ECC[e][v]*BLK[e][v];}
    function gmul(x,y){var z=0;for(var i=7;i>=0;i--){z=(z<<1)^((z>>>7)*0x11D);z^=((y>>>i)&1)*x;}return z&0xFF;}
    function rsDiv(d){var r=[];for(var i=0;i<d-1;i++)r.push(0);r.push(1);var root=1;for(i=0;i<d;i++){for(var j=0;j<r.length;j++){r[j]=gmul(r[j],root);if(j+1<r.length)r[j]^=r[j+1];}root=gmul(root,2);}return r;}
    function rsRem(data,div){var r=div.map(function(){return 0;});data.forEach(function(b){var f=b^r.shift();r.push(0);div.forEach(function(c,i){r[i]^=gmul(c,f);});});return r;}
    function alignPos(v,size){if(v===1)return[];var n=Math.floor(v/7)+2;var step=(v===32)?26:Math.ceil((v*4+4)/(n*2-2))*2;var r=[6];for(var p=size-7;r.length<n;p-=step)r.splice(1,0,p);return r;}
    function utf8(s){var o=[],e=unescape(encodeURIComponent(s));for(var i=0;i<e.length;i++)o.push(e.charCodeAt(i));return o;}
    function bit(x,i){return((x>>>i)&1)!==0;}

    return function(text,ecl){
      ecl=ecl||'L';
      var bytes=utf8(text),ver,cap;
      for(ver=1;ver<=40;ver++){cap=dataCw(ver,ecl)*8;var need=4+(ver<10?8:16)+bytes.length*8;if(need<=cap)break;}
      if(ver>40)throw new Error('QR: data too long');
      var bb=[];function app(val,len){for(var i=len-1;i>=0;i--)bb.push((val>>>i)&1);}
      app(4,4);app(bytes.length,ver<10?8:16);bytes.forEach(function(b){app(b,8);});
      app(0,Math.min(4,cap-bb.length));app(0,(8-bb.length%8)%8);
      for(var pad=0xEC;bb.length<cap;pad^=0xEC^0x11)app(pad,8);
      var dat=[];for(var i=0;i<bb.length;i+=8){var b=0;for(var j=0;j<8;j++)b=(b<<1)|bb[i+j];dat.push(b);}
      /* ecc + interleave */
      var nb=BLK[ecl][ver],el=ECC[ecl][ver],raw=Math.floor(rawMods(ver)/8),nShort=nb-raw%nb,sLen=Math.floor(raw/nb),div=rsDiv(el),blocks=[],k=0;
      for(i=0;i<nb;i++){var d=dat.slice(k,k+sLen-el+(i<nShort?0:1));k+=d.length;var ec=rsRem(d,div);if(i<nShort)d.push(0);blocks.push(d.concat(ec));}
      var all=[];for(i=0;i<blocks[0].length;i++)for(j=0;j<blocks.length;j++)if(i!==sLen-el||j>=nShort)all.push(blocks[j][i]);
      /* matrix */
      var size=ver*4+17,M=[],F=[];for(i=0;i<size;i++){M.push(new Array(size).fill(false));F.push(new Array(size).fill(false));}
      function set(x,y,on){M[y][x]=on;F[y][x]=true;}
      for(i=0;i<size;i++){set(6,i,i%2===0);set(i,6,i%2===0);}
      [[3,3],[size-4,3],[3,size-4]].forEach(function(c){for(var dy=-4;dy<=4;dy++)for(var dx=-4;dx<=4;dx++){var dist=Math.max(Math.abs(dx),Math.abs(dy)),xx=c[0]+dx,yy=c[1]+dy;if(xx>=0&&xx<size&&yy>=0&&yy<size)set(xx,yy,dist!==2&&dist!==4);}});
      var ap=alignPos(ver,size),n=ap.length;
      for(i=0;i<n;i++)for(j=0;j<n;j++){if((i===0&&j===0)||(i===0&&j===n-1)||(i===n-1&&j===0))continue;for(var dy2=-2;dy2<=2;dy2++)for(var dx2=-2;dx2<=2;dx2++)set(ap[i]+dx2,ap[j]+dy2,Math.max(Math.abs(dx2),Math.abs(dy2))!==1);}
      function fmt(mask){var data=FMT[ecl]<<3|mask,rem=data;for(var i=0;i<10;i++)rem=(rem<<1)^((rem>>>9)*0x537);var bits=(data<<10|rem)^0x5412;
        for(i=0;i<=5;i++)set(8,i,bit(bits,i));set(8,7,bit(bits,6));set(8,8,bit(bits,7));set(7,8,bit(bits,8));
        for(i=9;i<15;i++)set(14-i,8,bit(bits,i));for(i=0;i<8;i++)set(size-1-i,8,bit(bits,i));for(i=8;i<15;i++)set(8,size-15+i,bit(bits,i));set(8,size-8,true);}
      fmt(0);
      if(ver>=7){var rem=ver;for(i=0;i<12;i++)rem=(rem<<1)^((rem>>>11)*0x1F25);var vb=ver<<12|rem;for(i=0;i<18;i++){var a=size-11+i%3,c=Math.floor(i/3);set(a,c,bit(vb,i));set(c,a,bit(vb,i));}}
      var bi=0;for(var right=size-1;right>=1;right-=2){if(right===6)right=5;for(var vert=0;vert<size;vert++)for(j=0;j<2;j++){var x=right-j,up=((right+1)&2)===0,y=up?size-1-vert:vert;if(!F[y][x]&&bi<all.length*8){M[y][x]=bit(all[bi>>>3],7-(bi&7));bi++;}}}
      function inv(m,x,y){switch(m){case 0:return(x+y)%2===0;case 1:return y%2===0;case 2:return x%3===0;case 3:return(x+y)%3===0;case 4:return(Math.floor(x/3)+Math.floor(y/2))%2===0;case 5:return x*y%2+x*y%3===0;case 6:return(x*y%2+x*y%3)%2===0;default:return((x+y)%2+x*y%3)%2===0;}}
      function applyMask(m){for(var y=0;y<size;y++)for(var x=0;x<size;x++)if(!F[y][x]&&inv(m,x,y))M[y][x]=!M[y][x];}
      function penalty(){var p=0,dark=0,x,y,run,col;
        for(y=0;y<size;y++){run=1;for(x=1;x<size;x++){if(M[y][x]===M[y][x-1]){run++;if(run===5)p+=3;else if(run>5)p++;}else run=1;}}
        for(x=0;x<size;x++){run=1;for(y=1;y<size;y++){if(M[y][x]===M[y-1][x]){run++;if(run===5)p+=3;else if(run>5)p++;}else run=1;}}
        for(y=0;y<size-1;y++)for(x=0;x<size-1;x++){col=M[y][x];if(col===M[y][x+1]&&col===M[y+1][x]&&col===M[y+1][x+1])p+=3;}
        for(y=0;y<size;y++)for(x=0;x<size;x++)if(M[y][x])dark++;
        p+=Math.floor(Math.abs(dark*20-size*size*10)/(size*size))*10;return p;}
      var best=0,bestP=Infinity;
      for(var m=0;m<8;m++){applyMask(m);fmt(m);var pp=penalty();if(pp<bestP){bestP=pp;best=m;}applyMask(m);}
      applyMask(best);fmt(best);
      return {size:size,modules:M};
    };
  })();
  window.rsQr=rsQr;

  function qrSvg(text){
    var q=rsQr(text,'L'),s=q.size,b=4,d='';
    for(var y=0;y<s;y++)for(var x=0;x<s;x++)if(q.modules[y][x])d+='M'+(x+b)+' '+(y+b)+'h1v1h-1z';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+(s+2*b)+' '+(s+2*b)+'" shape-rendering="crispEdges" role="img" aria-label="QR code to start a WhatsApp chat"><rect width="100%" height="100%" fill="#fff"/><path d="'+d+'" fill="#0f0c09"/></svg>';
  }

  /* ---------- page context ---------- */
  function pageUrl(){return location.origin+location.pathname;}
  function product(){
    var src=document.querySelector('#rgdTrialBtn')||document.querySelector('#rgsTrialBtn');
    return src&&src.dataset.handle?src.dataset:null;
  }
  function waHref(msg){return 'https://wa.me/'+NUMBER+'?text='+encodeURIComponent(msg);}
  function genericMsg(){return 'Hi, I have a question about your rugs ('+pageUrl()+')';}
  function qrMsg(){
    var p=product();
    return p?'Hi, I’m looking at '+p.title+' — '+pageUrl():genericMsg();
  }
  function desktop(){return window.matchMedia('(min-width:1024px)').matches;}

  var panel,lastFocus,openedAt=0;
  function build(){
    if(panel)return panel;
    panel=document.createElement('div');
    panel.className='rs-wa-panel';
    panel.id='rsWaPanel';
    panel.setAttribute('role','dialog');
    panel.setAttribute('aria-modal','false');
    panel.setAttribute('aria-labelledby','rsWaPanelTitle');
    panel.innerHTML=
      '<button type="button" class="rs-wa-x" aria-label="Close chat panel">&times;</button>'+
      '<div class="rs-wa-hd"><span class="rs-wa-dot" aria-hidden="true"></span><span>WhatsApp</span></div>'+
      '<h2 class="rs-wa-t" id="rsWaPanelTitle">Chat with The Rug Shed</h2>'+
      '<p class="rs-wa-sub" id="rsWaSub"></p>'+
      '<div class="rs-wa-rug" id="rsWaRug" hidden><img alt="" id="rsWaRugImg"><div><div class="rs-wa-rug-t" id="rsWaRugT"></div><div class="rs-wa-rug-p" id="rsWaRugP"></div></div></div>'+
      '<div class="rs-wa-qr" id="rsWaQr"></div>'+
      '<p class="rs-wa-cap">Scan with your phone camera &mdash; WhatsApp opens with your message ready.</p>'+
      '<div class="rs-wa-or"><span>or</span></div>'+
      '<a class="rs-wa-btn" id="rsWaOpen" target="_blank" rel="noopener">Open WhatsApp on this computer</a>'+
      '<a class="rs-wa-alt" href="/pages/contact-us">Prefer email? Send us a message</a>';
    document.body.appendChild(panel);
    panel.querySelector('.rs-wa-x').addEventListener('click',close);
    return panel;
  }
  function open(opts){
    opts=(opts&&opts.msg)?opts:{};
    var link=document.querySelector('.whatsapp-icon a');
    build();
    var p=(opts.msg&&!opts.showRug)?null:product();
    document.getElementById('rsWaPanelTitle').textContent=opts.title||'Chat with The Rug Shed';
    document.getElementById('rsWaSub').textContent=opts.sub||(p?'Ask about this rug, request a video walkthrough or book a free home trial.':'Ask about a rug, sizes or a free home trial — we reply on WhatsApp.');
    var rug=document.getElementById('rsWaRug');
    if(p){rug.hidden=false;document.getElementById('rsWaRugImg').src=p.img||'';document.getElementById('rsWaRugT').textContent=p.title||'';document.getElementById('rsWaRugP').textContent=p.price||'';}
    else rug.hidden=true;
    var qr=document.getElementById('rsWaQr');
    try{qr.innerHTML=qrSvg(waHref(opts.msg||qrMsg()));qr.hidden=false;}catch(e){qr.hidden=true;}
    document.getElementById('rsWaOpen').href=opts.msg?waHref(opts.msg):(link?link.href:waHref(genericMsg()));
    lastFocus=document.activeElement;
    openedAt=Date.now();
    panel.classList.add('open');
    if(link)link.setAttribute('aria-expanded','true');
    setTimeout(function(){panel.querySelector('.rs-wa-x').focus();},30);
  }
  function close(){
    if(!panel||!panel.classList.contains('open'))return;
    panel.classList.remove('open');
    var link=document.querySelector('.whatsapp-icon a');
    if(link)link.setAttribute('aria-expanded','false');
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
  }
  window.rsWaOpenPanel=open;

  function init(){
    var wrap=document.querySelector('.whatsapp-icon'),link=wrap&&wrap.querySelector('a');
    if(!link)return;
    if(link.href.indexOf('text=')===-1)link.href=waHref(genericMsg());
    link.setAttribute('rel','noopener');
    link.setAttribute('aria-label','Chat with us on WhatsApp');
    link.setAttribute('aria-haspopup','dialog');
    if(!link.querySelector('.rs-wa-label')){
      var lab=document.createElement('span');
      lab.className='rs-wa-label';
      lab.innerHTML='<b>Chat with us</b><small>on WhatsApp</small>';
      link.appendChild(lab);
    }
    link.addEventListener('click',function(e){
      if(!desktop())return;
      e.preventDefault();
      if(panel&&panel.classList.contains('open'))close();else open();
    });
    /* the product-page nudge bubble opens the panel on desktop instead of a new tab */
    document.addEventListener('click',function(e){
      var n=e.target.closest&&e.target.closest('#rgsWaNudge');
      if(!n||!desktop()||e.target.closest('.rgs-wa-nudge-x'))return;
      e.preventDefault();e.stopPropagation();
      n.classList.remove('show');
      try{sessionStorage.setItem('rgs_wa_nudge','1');}catch(err){}
      open();
    },true);
    /* any other WhatsApp link on the page (e.g. product-page "Video Walkthrough", "WhatsApp Us")
       opens the same panel on desktop, keeping that link's own pre-filled message */
    document.addEventListener('click',function(e){
      if(e.defaultPrevented||!desktop())return;
      var a=e.target.closest&&e.target.closest('a[href*="wa.me/"]');
      if(!a||a.closest('.whatsapp-icon')||a.closest('#rsWaPanel'))return;
      var msg='';try{msg=new URL(a.href).searchParams.get('text')||'';}catch(err){}
      e.preventDefault();
      if(!msg){open();return;}
      var video=/video walkthrough/i.test(msg);
      open({msg:msg,showRug:true,
        title:video?'Request a video walkthrough':'Chat with The Rug Shed',
        sub:video?'Scan with your phone and we’ll send you a video of this rug on WhatsApp.':'Scan with your phone to open WhatsApp with your message ready.'});
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    document.addEventListener('click',function(e){
      if(!panel||!panel.classList.contains('open')||Date.now()-openedAt<300)return;
      if(panel.contains(e.target)||(wrap&&wrap.contains(e.target)))return;
      close();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* ============================================================
   RUG SHED — "SEND PHOTOS ON WHATSAPP" (added 2026-09-26)
   Shopify's contact form can't carry file attachments, so under the
   Cleaning & Repair quote form (#rgs-book) and the Contact page form
   (#rs-contact-form) we add a WhatsApp button whose pre-filled message
   names the customer and the service they picked. Phones: opens
   WhatsApp so they attach photos from the camera roll. Desktop: opens
   the QR chat panel. After a quote is submitted it becomes the next step.
   ============================================================ */
(function(){
  var NUMBER='447867610656';
  var WA_SVG='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>';

  function waHref(m){return 'https://wa.me/'+NUMBER+'?text='+encodeURIComponent(m);}
  function val(form,sel){var el=form.querySelector(sel);return el&&el.value?el.value.trim():'';}
  function message(kind,form){
    var name=val(form,'[name="contact[first_name]"]');
    var hi=name?'Hi, I’m '+name+'. ':'Hi, ';
    if(kind==='clean'){
      var svc=val(form,'#rgs-service-select');
      var what=(svc&&svc!=='Not sure')?svc:'cleaning or repair';
      return hi+'I’d like a quote for '+what+' — here are some photos of my rug:';
    }
    var subj=val(form,'#rs-cf-subject');
    return hi+(name?'Here':'here')+' are some photos for my enquiry'+(subj?' ('+subj+')':'')+':';
  }
  function desktop(){return window.matchMedia('(min-width:1024px)').matches;}

  function add(form,kind){
    if(!form||form.parentNode.querySelector('.rs-wph'))return;
    var posted=/contact_posted=true/.test(location.search)||(kind==='clean'&&/Thank you!/.test(form.textContent));
    var box=document.createElement('div');
    box.className='rs-wph '+(kind==='clean'?'rs-wph--dark':'rs-wph--light')+(posted?' rs-wph--next':'');
    box.innerHTML=
      '<div class="rs-wph-row"><span class="rs-wph-ic">'+WA_SVG+'</span><div>'+
      '<p class="rs-wph-t">'+(posted?'Next step: send us photos':'Got photos? Send them on WhatsApp')+'</p>'+
      '<p class="rs-wph-s">'+(posted?'We’ve got your request. Photos of the rug help us give you an accurate quote, faster.':'Photos of stains, damage or fringes help us quote accurately — full quality, no size limit.')+'</p>'+
      '</div></div>'+
      '<a class="rs-wph-btn" target="_blank" rel="noopener">'+WA_SVG+'<span>Send photos on WhatsApp</span></a>';
    form.parentNode.insertBefore(box,form.nextSibling);
    var btn=box.querySelector('.rs-wph-btn');
    function refresh(){btn.href=waHref(message(kind,form));}
    refresh();
    form.addEventListener('input',refresh);
    form.addEventListener('change',refresh);
    btn.addEventListener('click',function(e){
      refresh();
      if(desktop()&&window.rsWaOpenPanel){
        e.preventDefault();
        window.rsWaOpenPanel({msg:message(kind,form),title:'Send us photos',sub:'Scan with your phone to open WhatsApp with your message ready, then attach photos from your camera roll.'});
      }
    });
  }
  function init(){
    var book=document.getElementById('rgs-book');
    add(book&&book.querySelector('form'),'clean');
    add(document.getElementById('rs-contact-form'),'contact');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
